//HDI Priority
export const HDI_TICKET_PRIORITY_P1 = 'P1';
export const HDI_TICKET_PRIORITY_P2 = 'P2';
export const HDI_TICKET_PRIORITY_P3 = 'P3';
export const HDI_TICKET_PRIORITY_P4 = 'P4';
